const forms = {
  state: {
    hazard: null,
    hazardDID: null,
    hazardRegister: null,
    hazardRegisterCounter: 0,
    hazardAnalysisList: null,
    hazardAnalysisListCounter: 0
  },
  mutations: {
    changeHazardRegister(state, payload) {
      state.hazardRegister = payload;
    },
    changeHazardRegisterCounter(state, payload) {
      state.hazardRegisterCounter = payload;
    },
    changeHazard(state, payload) {
      state.hazard = payload;
    },
    changeHazardDID(state, payload) {
      state.hazardDID = payload;
    },
    changeHazardAnalysisList(state, payload) {
      state.hazardAnalysisList = payload;
    },
    changeHazardAnalysisListCounter(state, payload) {
      state.hazardAnalysisListCounter = payload;
    }
  },
  actions: {
    changeHazardRegister({ commit }, payload) {
      commit("changeHazardRegister", payload);
    },
    changeHazardRegisterCounter({ commit }, payload) {
      commit("changeHazardRegisterCounter", payload);
    },
    changeHazard({ commit }, payload) {
      // commit to store
      commit("changehazard", payload);
    },
    changeHazardDID({ commit }, payload) {
      // commit to store
      commit("changehazardDID", payload);
    },
    changeHazardAnalysisList({ commit }, payload) {
      commit("changeHazardAnalysisList", payload);
    },
    changeHazardAnalysisListCounter({ commit }, payload) {
      commit("changeHazardAnalysisListCounter", payload);
    }
  },
  getters: {
    getHazardRegister: state => {
      return state.hazardRegister;
    },
    getHazardRegisterCounter: state => {
      return state.hazardRegisterCounter;
    },
    getHazard: state => {
      return state.hazard;
    },
    getHazardDID: state => {
      return state.hazardDID;
    },
    getHazardAnalysisList: state => {
      return state.hazardAnalysisList;
    },
    getHazardAnalysisListCounter: state => {
      return state.hazardAnalysisListCounter;
    }
  }
};
// eslint-disable-next-line
export default forms;
